import { ApiEndpoint } from '../api';

export const DEFAULT_TIME_OFFSET_SECONDS = 30;
export const CSRF_HEADER_NAME = 'X-CSRF-Token';

export const CRSF_EXCLUDED_ENDPOINTS = [
  ApiEndpoint.Crsf,
  ApiEndpoint.OAuthLogin,
];
